import { Turbo } from '@hotwired/turbo-rails';

Turbo.StreamActions.redirect_to = function redirectTo() {
  const { url } = this.dataset;
  if (url.startsWith('/')) {
    Turbo.visit(url);
  } else {
    window.location.href = url;
  }
};

Turbo.StreamActions.data_layer_push = function dataLayerPush() {
  const { message } = this.dataset;
  window.dataLayer ||= [];
  window.dataLayer.push(JSON.parse(message));
};
